import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="InstBit" link="https://instbit.netlify.app" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
  Built a web based tool using ReactJS & NodeJS to schedule and automatically post images/video posts to user’s Instagram Business Account using Facebook’s Graph API.
    </ProjectCard>
    <ProjectCard title="Wordle Bit" link="https://wordlebit.vercel.app" bg="linear-gradient(to right, #662D8C 0%, #ED1E79 100%)" mdxType="ProjectCard">
  Built a clone of the popular English Wordle game using ReactJS (Typescript).
Designed reusable UI & Type-safe components using Typescript and ES6 features.
    </ProjectCard>
    <ProjectCard title="Music Bit" link="https://github.com/sleebit/music_bit" bg="linear-gradient(to right, #009245 0%, #FCEE21 100%)" mdxType="ProjectCard">
  Modern Music App Interface which serves music via Youtube player. It's layout is inspired from TikTok style Homescreen (Vertical Swipable Components).
  Made in Flutter, a Cross Platform Mobile Application Development Kit by Google.
    </ProjectCard>
    <ProjectCard title="P2P Trade Website (Freelancing)" bg="linear-gradient(to right, #D585FF 0%, #00FFEE 100%)" mdxType="ProjectCard">
  A website for Trading Virtual Characters in the site and earn profit at the time of its Resale.
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      